<template>
  <div
    class="flex items-center rounded-md px-4 py-2 text-base"
    :class="{
      'bg-alert-info text-brand': type === 'info',
      'bg-alert-warning text-warning': type === 'warning',
      'bg-alert-error text-negative': type === 'error',
      'bg-alert-success text-positive': type === 'success',
      'justify-start text-left': align == 'left',
      'justify-center text-center': align == 'center',
      'justify-end text-right': align == 'right',
    }"
  >
    <SvgIcon v-if="icon" :icon="icon" class="w-4 h-4 mr-4 shrink-0" />
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import SvgIcon from '@/components/misc/SvgIcon'

export default defineComponent({
  components: {
    SvgIcon,
  },

  props: {
    type: {
      type: String as PropType<'info' | 'warning' | 'error' | 'success'>,
      default: 'info',
    },
    icon: {
      type: String as PropType<string | null>,
      default: null,
    },
    align: {
      type: String as PropType<'left' | 'center' | 'right'>,
      default: 'left',
    },
  },
})
</script>
